import Citation, { CitationFromJson } from './Citation'
import Bill from './Bill'

export interface LicenseFromJson {
  id: number
  state: string
  number: string
  bill: Bill|null
  citations: CitationFromJson[]|null
}

class License {
  id: number
  state: string
  number: string
  bill: Bill|null
  citations: Citation[]|null

  constructor (id: number, state: string, number: string, bill: Bill|null, citations: Citation[]|null) {
    this.id = id
    this.state = state
    this.number = number
    this.bill = bill
    this.citations = citations
  }

  static fromJson ({ id, state, number, bill, citations }: LicenseFromJson) {
    return new License(
      id,
      state,
      number,
      bill ?? null,
      citations ? citations.map((citation: CitationFromJson) => Citation.fromJson(citation)) : null
    )
  }

  shallowClone () {
    return new License(
      this.id,
      this.state,
      this.number,
      this.bill,
      this.citations
    )
  }
}

export default License
